import { render, staticRenderFns } from "./ListReports.vue?vue&type=template&id=3e81c4ca"
import script from "./ListReports.vue?vue&type=script&lang=js"
export * from "./ListReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e81c4ca')) {
      api.createRecord('3e81c4ca', component.options)
    } else {
      api.reload('3e81c4ca', component.options)
    }
    module.hot.accept("./ListReports.vue?vue&type=template&id=3e81c4ca", function () {
      api.rerender('3e81c4ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/List/ListReports.vue"
export default component.exports